import {
    APPLICANT_ATTRIBUTION_BOTH,
    EUROPACE_INSURED_RISKS,
    LOAN_REQUEST_OFFER_BANKS,
    LOAN_REQUEST_OFFER_STATUS,
    OFFER_ACCEPTANCE_STATUSES,
} from 'cpool-constants';
import { schemaManualOffer } from 'cpool-schemas';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_OfferRecorded extends _Event {
    constructor(payload: EventSchema<LoanRequest_OfferRecorded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return schemaManualOffer;
    }

    static example(): EventSchema<LoanRequest_OfferRecorded> {
        return {
            acceptanceStatus: OFFER_ACCEPTANCE_STATUSES.SUCCESS,
            acceptedAt: 1719470304178,
            applicant1ResidualDebtInsurance: [EUROPACE_INSURED_RISKS.ARBEITSLOSIGKEIT],
            applicant2ResidualDebtInsurance: [EUROPACE_INSURED_RISKS.ARBEITSLOSIGKEIT],
            applicantAttribution: APPLICANT_ATTRIBUTION_BOTH.BEIDE,
            bank: LOAN_REQUEST_OFFER_BANKS.Commerzbank,
            commissionResponseInPercent: 2,
            creditAmount: 1000,
            file: {
                fileExtension: 'pdf',
                key: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
                mimeType: 'application/pdf',
                name: 'Angebot.pdf',
            },
            id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
            interest: 2.5,
            providerApplicationNumber: '123asdasd1',
            rate: 100,
            runtime: 24,
            status: LOAN_REQUEST_OFFER_STATUS.APPROVED,
        };
    }
}

// INFO yup schema
// static get SCHEME() {
//     return yup.object({
//         amount: yup.number().required(),
//         bank: yup.string().oneOf(loanRequestOfferBank).required(),
//         file: yup.object({
//             fileExtension: yup.string(),
//             key: yup.string().required(),
//             mimeType: yup.string().required(),
//             name: yup.string().required(),
//         }),
//         id: yup.string().required(),
//         offerCommission: yup.number().required(),
//         paidCommission: yup.number().required(),
//         preSalesTransition: yup.string().oneOf(loanRequestOfferPST).required(),
//         residualDebtInsurance: yup.string().oneOf(loanRequestOfferRDI).required(),
//         status: yup.string().oneOf(loanRequestOfferStatuses).required(),
//     });
// }
